import React, { useContext } from "react";
import { GlobalContext } from "GlobalContext";
import {
  SubMenuWrapper,
  SubMenuContainer,
  Menu,
  MenuItem,
  Address,
  MenuItemLink,
  SocialIcons,
  ToTop,
} from "./styles/SubMenuStyles";

const SubMenu = ({ data, navigateTo }) => {
  const { currentLang } = useContext(GlobalContext);
  const {
    adresse,
    libelleContact,
    lienContact,
    libelleMentionsLegales,
    lienMentionsLegales,
    copyright,
    socials,
  } = data;

  // The CMS text still says 2020; keep its wording, always show this year.
  const copyrightText = (copyright || "")
    .replace(/<\/?p>/g, "")
    .replace(/(©\s*)\d{4}/, "$1" + new Date().getFullYear());

  const link = (slug) => ({
    href: (currentLang === "en" ? "/en/" : "/") + slug,
    onClick: (e) => {
      if (e.metaKey || e.ctrlKey || e.shiftKey) return;
      e.preventDefault();
      navigateTo("/" + slug);
    },
  });

  return (
    <SubMenuWrapper className="SubMenu">
      <SubMenuContainer>
        <Menu>
          <Address>
            <svg viewBox="0 0 24 24" aria-hidden="true">
              <path d="M12 21s-7-6.2-7-11.5a7 7 0 0 1 14 0C19 14.8 12 21 12 21z" />
              <circle cx="12" cy="9.5" r="2.5" />
            </svg>
            <span dangerouslySetInnerHTML={{ __html: adresse }} />
          </Address>
          <MenuItem dangerouslySetInnerHTML={{ __html: copyrightText }} />
          {libelleMentionsLegales && lienMentionsLegales && (
            <MenuItem>
              <MenuItemLink {...link(lienMentionsLegales.slug)}>
                {libelleMentionsLegales}
              </MenuItemLink>
            </MenuItem>
          )}
          {libelleContact && lienContact && (
            <MenuItem>
              <MenuItemLink {...link(lienContact.slug)}>
                {libelleContact}
              </MenuItemLink>
            </MenuItem>
          )}
        </Menu>
        <SocialIcons>
          {socials &&
            socials.map((item, i) => (
              <a
                href={item.lien}
                key={i}
                target="_blank"
                rel="noopener noreferrer"
                aria-label={item.plateforme}
              >
                <img src={item.icone.sourceUrl} alt="" />
              </a>
            ))}
        </SocialIcons>
        <ToTop
          type="button"
          aria-label={currentLang === "en" ? "Back to top" : "Retour en haut"}
          onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
        >
          <svg viewBox="0 0 24 24" aria-hidden="true">
            <path d="M12 19V5M6 11l6-6 6 6" />
          </svg>
        </ToTop>
      </SubMenuContainer>
    </SubMenuWrapper>
  );
};

export default SubMenu;
